export const components = {
  emptyState: {
    primaryTitle: '¡Vaya!',
    primaryText: 'Todavía no hay nada aquí…',
    secondaryTitle: 'Nada que mostrar',
    secondaryText: 'Lamentablemente, no hay elementos para mostrar según los filtros aplicados…'
  },
  filters: {
    all: 'Todos',
    search: 'Buscar',
    priceRange: 'Rango de precios {currency}',
    minValue: '¡El valor mínimo es {val}!',
    maxValue: '¡El valor máximo es {val}!',
    reset: 'Reiniciar',
    apply: 'Aplicar'
  },
  comments: {
    reply: 'Responder',
    loadMore: 'Cargar más',
    edited: 'Editado',
    noComments: 'Todavía no hay comentarios',
    leaveFirstComment: 'Puedes dejar el primero'
  },
  curtain: {
    close: 'Cerrar'
  },
  photoPreview: {
    close: 'Cerrar'
  },
  photoCropper: {
    back: 'Atrás',
    save: 'Guardar'
  },
  rightSidebar: {
    in: 'en'
  },
  pushPrompt: {
    title: '“{appName}” quisiera enviarte notificaciones',
    description:
      'Las notificaciones pueden incluir alertas, sonidos e insignias de iconos. Estas pueden configurarse en Configuración.',
    later: 'Preguntar más tarde',
    neverLater: 'No volver a preguntar',
    allow: 'Permitir'
  },
  inAppPush: {
    attachment: 'Adjunto'
  },
  installPrompt: {
    android: {
      install: 'Instalar',
      description:
        'Para una experiencia sin interrupciones, no es necesario utilizar un navegador. Simplemente instálalo como una aplicación.',
      press: 'Presiona',
      andSelect: 'y selecciona',
      orSimply: 'o simplemente',
      description2: 'haz clic en el botón Instalar a continuación',
      notNow: 'Ahora no'
    },
    ios: {
      justTap: 'Toca el',
      buttonInBrowser: 'botón "Más" en tu navegador y selecciona "Compartir"',
      addToHomeScreen: 'Desplázate hacia abajo y toca "Añadir a la pantalla de inicio", luego haz clic en "Añadir"',
      appWillBeInstalled: 'La aplicación se añadirá a tu pantalla de inicio'
    },
    installApp: 'Instalar aplicación',
    useWeb: 'Usar versión web'
  },
  footer: {
    more: 'Menú'
  },
  menu: {
    installApp: 'Instalar aplicación',
    menu: 'Menú',
    close: 'Cerrar'
  },
  404: {
    whoops: '¡Vaya!',
    description:
      'Parece que la página no existe o tal vez no tienes acceso a ella. Por favor, contacta al propietario de la aplicación para más detalles.',
    ok: 'OK'
  },
  relatedUsers: {
    seeall: 'Ver todos'
  },
  networkingCurtain: {
    'newOneOnOne': 'Nuevo 1:1',
    'details': 'Detalles',
    'coverMessage': 'Mensaje de portada',
    'location': 'Ubicación',
    'duration': 'Duración',
    '15min': '15 min',
    '30min': '30 min',
    '45min': '45 min',
    '60min': '60 min',
    'timeSlot': 'Franja horaria',
    'sendInvitation': 'Enviar invitación',
    'success': 'Éxito',
    'invitationSent':
      'Has enviado con éxito la invitación a una reunión 1:1. ¿Quieres quedarte en esta página o navegar a todas tus reuniones 1:1 programadas?',
    'seeAll': 'Ver todas las reuniones 1:1',
    'stayHere': 'Quedarse aquí'
  },
  networking: {
    level: {
      1: 'Aún no listo para hacer networking. Sin actividad o compromiso significativo.',
      2: 'Rara vez activo o falta información clave en el perfil, lo que hace difícil conectar con otros.',
      3: 'Perfil completo con foto y en línea, completamente listo para comenzar a hacer networking.',
      4: 'Generando impulso: ha iniciado al menos una conexión en las últimas 6 horas.',
      5: 'Un maestro del networking: responde activamente a solicitudes e interactúa con otros en las últimas 6 horas.'
    }
  },
  time: {
    days: 'd',
    hours: 'h',
    minutes: 'm',
    seconds: 's',
    startsIn: 'en',
    Today: 'Hoy',
    today: 'hoy',
    Tomorrow: 'Mañana',
    tomorrow: 'mañana',
    Yesterday: 'Ayer',
    yesterday: 'ayer',
    startingNow: 'comienza ahora'
  },
  daysMonths: {
    months: "['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre']",
    monthsShort: "['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']",
    weekdays: "['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado']",
    weekdaysShort: "['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb']",
    weekdaysMin: "['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá']"
  },
  badges: {
    legend: 'Legendary Networker',
    push: 'Online and Trusted',
    leader: 'Leaderboard Champ',
    meetmaster: '1:1 Meeting Master',
    connector: '3-Time Connector',
    legend_description: 'Alcanza el nivel Legend al menos una vez mediante el networking activo y creando conexiones significativas.',
    push_description: 'Habilita las notificaciones push para mantenerte disponible y nunca perder una oportunidad.',
    leader_description: 'Alcanza al menos una vez el top 10% en la tabla de clasificación.',
    meetmaster_description: 'Inicia o responde al menos una solicitud de reunión 1:1 en la app.',
    connector_description: 'Establece al menos tres conexiones a través de la app durante los componentes.'
  }
}
